import { render, staticRenderFns } from "./EmployeeEditTemplate.vue?vue&type=template&id=6511c70c"
import script from "./EmployeeEditTemplate.vue?vue&type=script&lang=ts"
export * from "./EmployeeEditTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports